import React from 'react';
import { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { P } from '../../AbstractElements';
import pkg from '../../../package.json';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const appVersion = pkg.version;
  const buildDateFormatted = pkg.buildDate
    ? new Date(pkg.buildDate).toISOString().slice(0, 10)
    : '';

  return (
    <Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md="12" className="footer-copyright text-center">
              <P attrPara={{ className: "mb-0" }}>
                {`Copyright © ${currentYear} · v${appVersion}${buildDateFormatted ? ` (${buildDateFormatted})` : ''}`}
              </P>
            </Col>
          </Row>
        </Container>
      </footer>
    </Fragment>
  );
};

export default Footer;